const StatusMessageCategories = [
  {
    value: "Bankserv/3ds",
    label: "Bankserv/3DS",
  },
  {
    value: "Data/Sim",
    label: "Data/SIM",
  },
  {
    value: "Ecentric",
    label: "Ecentric",
  },
  {
    value: "Electricity",
    label: "Electricity",
  },
  {
    value: "Issuer",
    label: "Issuer",
  },
  {
    value: "Other",
    label: "Other",
  },
  {
    value: "SBSA_Maintenance",
    label: "SBSA maintenance",
  },
  {
    value: "TU",
    label: "ThumbzUp",
  },
];

export default StatusMessageCategories;
